export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_15-e65c022458e243f2c6881b436a39f417.jpg";